const en = {
  headerComponent: {
    home: "Home",
    aboutUs: "About Us",
    plans: "Plans",
    contact: "Contact",
    login: "Login",
    register: "Create Account",
    adm: {
      priceList: "Price List",
      reservations: "Reservations",
      users: "Users",
    },
    isntMobile: {
      isStoreOwner: {
        reservations: "Reservations",
        property: "Property",
        subscription: "Subscription",
      },
      isAuthenticated: {
        settings: "Settings",
        explanatoryVideos: "Explanatory Videos",
        logOut: "Log Out",
      },
    },
  },

  login: {
    welcomeBack: "Welcome Back!",
    text: "Log in to access your account and continue enjoying all the benefits we offer. It's quick and easy, and we're here to assist if you need any help!",
    password: "Password",
    submit: "Log in",
    forgotPassword: "Forgot your password??",
    error: {
      email: "Email is required",
      password: "Password is required",
      login: "Error logging in:",
    },
  },

  plans: {
    defaultErrorMessage: "Error fetching price list",
    errorAlert: "No tables found yet. Please try again.",
    pageName: "Plans",
    title: "Find the perfect plan for you",
    you: "you.",
    text: "Adjust the slider below to indicate your number of properties.",
    selectedProperties: "Selected properties",
    selectedProperty_1: "Selected property",
    perfectForYou: "Perfect for you",
    month: "month",
    perProperty: "Per property in this tier",
    planFor: "Plan for ",
    to: "to ",
    properties: " properties",
    continue: "Continue",
    tiersNotice:
      "Pricing is progressive: each tier's price applies to the properties that fall within that tier, and the tiers add up to your monthly total.",
    monthlyTotal: "Your monthly total",
    averagePerProperty: "That is {price} per property",
    breakdownTitle: "How we got to this amount",
    propertySingle: "Property {n}",
    propertyRange: "Properties {from} to {to}",
    fromPropertyOnwards: "{from} properties or more",
    quoteError: "We could not calculate your monthly total. Please try again.",
  },

  register: {
    createAccount: "Create Account",
    welcome: "Welcome to Selfie Check-in!",
    welcomeMessage:
      "We're excited to have you with us. Creating your account is quick and easy: fill in the fields below and our consultant will get in touch with you!",
    yourData: "Your Information",
    name: "Name",
    fullNameRequired: "Full name is required",
    email: "Email",
    emailRequired: "Email is required",
    invalidEmail: "Invalid email",
    phone: "Phone (WhatsApp)",
    phoneRequired: "Phone is required",
    invalidPhone: "Invalid phone",
    companyName: "Company name",
    companyNameRequired: "Company name is required",
    cnpj: "CNPJ",
    website: "Website",
    invalidWebsite: "Invalid website",
    cnpjRequired: "CNPJ is required",
    createPassword: "Create a password",
    passwordRequired: "Password is required",
    confirmPassword: "Confirm your password",
    confirmPasswordRequired: "Password confirmation is required",
    emailRegistered: "Email already registered",
    minPasswordLength: "Password must be at least 6 characters long",
    passwordMismatch: "Passwords must match",
    quantityRequired: "Quantity is required",
    quantityMustBeNumber: "Quantity must be a number",
    minQuantity: "Minimum quantity of properties is 1",
    maxQuantity: "Maximum quantity of properties is 1000",
    skipSubscription: "I do not wish to subscribe now",
    back: "Back",
    finishRegister: "Complete Registration",
  },

  aboutUs: {
    title: "ABOUT US",
    subtitleSpan: "We revolutionize your ",
    subtitle: "hosting experience",
    text: "By infusing innovation and security into every step. With cutting-edge technology and a practical touch, we make each stay safer, faster, and more reliable.",
    connected: {
      title: "Connected",
      textBrLeft: "Integrated with leading",
      textBrRight: "hosting platforms.",
    },
    secure: {
      title: "Secure",
      text: "All data is authenticated directly through Gov.br, ensuring peace of mind.",
    },
    userFriendly: {
      title: "User-Friendly",
      text: "Designed for convenience for both you and your guests.",
    },
    content1: {
      title:
        "Born from the real-world challenges faced by vacation rental hosts,",
      text: "Selfie Check-in addresses the need for a seamless blend of efficient booking processes and swift, user-friendly guest experiences.",
    },
    content2: {
      title: "Understanding that property security is paramount,",
      text: "we developed software that cross-verifies information and documents, ensuring data authenticity in a simple and efficient manner.",
    },
    caption:
      "We streamline your booking process to deliver the smooth and effective experience you and your guests deserve!",
  },

  importPreviousReservationData: {
    importReservationData: "import reservation data",
    sixDigitsCode: "6-digit code",
    confirm: "Confirm",
    resendCode: "Resend Code",
    await: "Please wait",
    continueWithoutImport: "Continue without Import",
    invalidDate: "Invalid date",
    close: "Close",
    errorSendingEmail: "Error sending email.",
    errorSendingWhatsApp: "Error sending WhatsApp.",
    errorSendingCode: "Error sending code.",
    dataImportedSuccessfully: "Data imported successfully!",
    informSixDigitsCode: "Please enter the 6-digit code.",
    youAlreadyIsOurClient:
      "We understand that you have already stayed at a Selfie Checkin partner agency. Would you like to import the data from any of your old reservations?",
    noInformedCompany: "Company not informed.",
    import: "Import",
    previousReservations: "Reservas anteriores",
  },
  goToPreviousReservation:
    "You already have an ongoing reservation. Would you like to go to it?",
  reservationInProgress: "Reservation in progress",

  contact: {
    contact: "Contact",
    title: "Get in touch with us",
    caption:
      "We're here to help and answer your questions. Fill out the form below or send us a direct message.",
    fields: {
      name: "Name",
      email: "Email",
      phone: "Phone (WhatsApp)",
      subject: "Subject",
      message: "Your Message",
      submit: "Send message",
    },
    text: "We optimize your booking process to provide the seamless and efficient experience you and your guests deserve!",
    validation: {
      name: "Name is required",
      email: {
        required: "Email is required",
        invalid: "Invalid email address",
      },
      phone: "Phone is required",
      subject: "Subject is required",
      message: "Message is required",
    },
    hubspotForm: {
      fields: {
        firstname: "Name",
        companyName: "Company name",
        email: "Email",
        phone: "Phone",
        propertiesCount: "How many properties/rooms do you manage?",
        usesChannelManager: "Do you use a channel manager?",
        whichChannelManager: "If so, which one?",
        submit: "Send",
      },
      options: {
        yes: "Yes",
        no: "No",
        other: "Other",
      },
      validation: {
        firstname: "Please enter your name",
        companyName: "Please enter your company name",
        email: {
          required: "Please enter your email",
          invalid: "Please enter a valid email",
        },
        phone: "Please enter your phone number",
        propertiesCount: "Please enter how many properties/rooms you manage",
        channelManagerUsage: "Please tell us whether you use a channel manager",
        whichChannelManager: "Please tell us which channel manager you use",
      },
    },
    success: "Form submitted successfully!",
    captcha: {
      required: "Please confirm that you are not a robot.",
      unavailable: "Captcha is not configured right now.",
    },
    error: {
      generic: "Error submitting form",
    },
  },

  fetchWrapper: {
    notConnectServer: "Could not connect to server. Please try again later.",
    internalServerError:
      "An internal server error has occurred. Please try again later.",
  },

  footerComponent: {
    title: "Don't waste time! Eliminate bureaucratic hassles.",
    freeTrialLink: "Try 30 Days Free",
    contact: "Contact",
    allRights: "All Rights Reserved",
  },

  reload: "Reload",
  towHours: "This field will be visible 2 hours before check-in.",
  edit: "Edit",
  create: "Create",
  stay: "Stay",
  yourStay: "Your Stay",
  welcome: "Welcome",
  addressD: "Address",
  earlyCheck: "Early check-in",
  reqLate: "Request Late Check-Out",
  mobCheck: "Mobile Check-Out",
  rebook: "Rebook Direct & Save",
  homeGuide: "Home Guide",
  homeD: "Home Tour",
  inventory: "Inventory/Starte Kits",
  coffeM: "Coffe Makers",
  tv: "Television Instructions",
  freezer: "Fridge/Freezer",
  cooling: "Heating & Cooling",
  laundry: "Laundry",
  trash: "Trash",
  pool: "Pool",
  hotTub: "Hot Tub",
  doorCode: "Door Code",
  areaGuide: "Area Guide",
  clearSky: "Clear sky",
  mainlyClear: "Mainly clear",
  partlyCloudy: "Partly cloudy",
  overcast: "Overcast",
  fog: "Fog",
  drizzle: "Drizzle",
  freezingDrizzle: "Freezing Drizzle",
  rain: "Rain",
  freezingRain: "Freezing Rain",
  snow: "Snow",
  snowGrains: "Snow grains",
  rainShowers: "Rain showers",
  snowShowers: "Snow showers",
  thunderstorm: "Thunderstorm",
  thunderstormHail: "Thunderstorm with hail",
  unknown: "Unknown",
  weatherLoading: "Getting weather forecast data...",
  weatherError: "Could not get the weather forecast.",
  nearBy: {
    mapUpdated: "Map updated to the selected location",
    addressCopied: "Address copied successfully!",
    restaurant: "Restaurant",
    bar: "Bar",
    market: "Market",
    bakery: "Bakery",
    pharmacy: "Pharmacy",
    mall: "Mall",
    bank: "Bank",
    theater: "Theater",
    cinema: "Cinema",
    museum: "Museum",
    park: "Park",
    tourist_spot: "Tourist Spot",
    beach: "Beach",
    stadium: "Stadium",
    subway_train: "Subway / Train",
    other: "Other",
    gym: "Gym",
    auditorium: "Auditorium",
    bars: "Bars",
    library: "Library",
    boutique: "Boutique & Fashion Stores",
    atm: "ATMs & Currency Exchange",
    cafe: "Café",
    show_house: "Show Houses & Performances",
    cultural_center: "Cultural Centers",
    convention_center: "Convention Centers",
    clinic: "Clinics & Hospitals",
    coworking: "Co-workings",
    sweet_shop: "Sweet Shops",
    event_space: "Event Spaces",
    handicraft_fair: "Handicraft Fairs",
    food_truck: "Food Trucks",
    art_gallery: "Art Galleries",
    laundry: "Laundries",
    car_rental: "Car & Bike Rentals",
    convenience_store: "Convenience Stores",
    souvenir_store: "Souvenir Stores",
    open_market: "Markets & Open Fairs",
    flea_market: "Flea Markets",
    viewpoint: "Viewpoints & Tourist Spots",
    gas_station: "Gas Stations",
    boat_tour: "Boat Tours & Water Sports",
    salon: "Beauty Salons & Barber Shops",
    transport_services: "Transport Services (Taxis, Uber, etc.)",
    ice_cream_shop: "Ice Cream Shops",
    spa: "Spas & Massage Centers",
    trails: "Hiking Trails",
    winery: "Wineries & Craft Breweries",
    yoga: "Yoga & Meditation",
    university: "University",
    airport: "Airport",
    parking: "Parking",
  },
  nameLabel: "Location Name",
  cepLabel: "ZIP Code",
  streetLabel: "Street",
  numberLabel: "Number",
  typeLabel: "Type",
  complementLabel: "Complement (Optional)",
  neighborhoodLabel: "Neighborhood",
  cityLabel: "City",
  stateLabel: "State",
  addPlace: "Add Location",
  nearbyPlacesI: "Nearby Locations",
  cuisine: "Cuisine",
  establishment: "Establishment",
  details: "Show details",
  zipError: "Error when fetching zip code",
  lang: "en_US",
  failedFetchLivenessSession: "Liveness start failed",
  failedCheckLivenessSession: "Liveness result inconsistent. Try again.",
  cutImage: "Cut the image",
  rotateImage: "Rotate",
  saveCut: "Save",
  saveAdditionalGuest: "Save",
  maxGuestsReached: "Max guests reached!",
  cancelCut: "Cancel",
  infoForGuests:
    "You can fill in the other guest's details or send them the link to fill in themselves",
  guestAlreadyRegisteredWarning:
    "The guest already registered previously should not be added as an additional guest.",
  noAdditionalGuests: "No additional guests registered",
  wasRefused:
    "Your reservation submission requires adjustments. Please review the following point(s).",
  property: "Property",
  back: "Back",
  reservationCode: "Reservation Code",
  errorLoad: "Error while loading data. Try again",
  hi: "Hi",
  close: "Close",
  chooseOptionBelow: "Choose the option below",
  fillData: "Fill personal data",
  seeDetails: "Check reservation details",
  reservationInApproval: "Reservation pending approval",
  waitingApproval:
    "<strong>Your reservation is under approval.</strong> Once completed, all access details and information about the accommodation will be available here.",
  reservationDetails:
    "Full address, access details, passwords, rules, and tips.",
  advertiseNavigateThroughNextAndBackButtons:
    "To navigate through the tabs, use the next and back buttons below",
  inAnalysis: "In analysis, please, wait.",
  accessToPlace: "Access to place",
  filled: "ALREADY IN ANALISYS OR FINISHED!",
  CodeCopy: "Code copied successfully!",
  AddressCopy: "Address copied successfully!",
  loading_indicator: "Loading data, please wait.",
  step1: "Stay",
  step2: "Main Guest<br/> Reservation Data",
  step3: "Additional Guests",
  step4: "Deposit Payment",
  step4AdditionalMode: "Your data",
  step5: "Main guest document",
  name: "Full name of the Guest",
  cpf: "CPF",
  foreignDocument: "Document (Passport, RNE)",
  isInternational: "international?",
  changeCheckinAndCheckoutTime:
    "To change the dates and times of your stay, please contact support via WhatsApp, click here.",
  isForeign: "foreigner?",
  email: "Guest's email",
  phone: "Guest's phone",
  phone_whats: "Guest's phone number",
  birthDate: "Date of birth",
  address: "Guest's address",
  cep: "Zip Code",
  postalCode: "Postal Code",
  city: "City",
  state: "State",
  country: "Country",
  number: "Number",
  addressLine1: "Address Line 1",
  addressLine2: "Address Line 2",
  street: "Street",
  obs: "Complement",
  residenceShortAddress: "Place",
  checkInDate: "Check-in date",
  checkOutDate: "Check-out date",
  checkInTime: "Check-in time",
  checkInTimeSelector: "Select checkin time",
  checkOutTime: "Check-out time",
  checkOutTimeSelector: "Select checkout time",
  checkinCheckoutTimeSelectorClose: "Close",
  visitPurpose: "Purpose of the visit",
  havePets: "Have pets?",
  bringPets: "Bring pets",
  bringPets_hint: "This field is only for properties that allow pets.",
  adults: "Number of adults",
  adults_info:
    "This number corresponds to the total number of adults who are filling out the form or making the reservation.",
  children: "Number of children",
  submit: "SUBMIT DATA",
  prev: "Back",
  next: "Next",
  cancel: "Cancel",
  yes: "Yes",
  no: "No",
  noData: "No data to display",
  noAirbnb: "No deposit, booking via Airbnb",
  chooseCaptureMethod: "Choose an option",
  captureOrUpload: "Take photo",
  sendFile: "Send File",
  attachFile: "Attach File",
  changeFile: "Change File",
  submitSuccess: "Data sent successfully. We'll get in touch soon.",
  submitSuccessAdditional: "Data sent successfully.",
  failedLoadReservation: "Error while loading reservation data",
  submitError: "Error while saving data. Try again.",
  errors: {
    STAYS_DUPLICATED_EMAIL:
      "Error: 453534 - Email Duplicated - Contact support.",
  },
  errorLoadingForm: "Error while loading data. Try again.",
  description: "Description",
  allAlright: "Everything alright, wait for access release",
  justMainGuestCanFill:
    "Attention: only the main guest of the reservation should fill out this link.",

  // ----------validationSchema----------
  visitPurposes: {
    leisure: "Leisure - Vacation",
    work: "Business",
    shopping: "Shopping",
    familyFriends: "Family - Friends",
    congressFair: "Congress - Fair",
    course: "Study - Courses",
    healthTreatment: "Health",
    religion: "Religion",
    other: "Other",
    notInformed: "Not informed",
  },
  dontInformPurpose: "I prefer not to inform the purpose of the visit",
  termsConfirmation:
    "By continuing, you declare that you have read and accept our data privacy and security terms",
  termsAcceptanceTitle: "Accept Terms of Use And Privacy Policies",
  termsAcceptanceMessage:
    "To proceed with the form, you must accept our terms of use and privacy policies.",
  termsCheckboxLabel: "I have read and accept the {link}",
  imageTermsCheckboxLabel: "I accept the {link}",
  imageTermsOfUse: "image usage terms",
  imageTermsTitle: "Image Usage Terms",
  userTermsCheckboxLabel: "I have read and accept the {link}",
  userTermsOfUse: "Terms of use {companyName}",
  userTermsTitle: "Terms of Use {companyName}",
  doNotAccept: "Do not accept",
  continueButton: "Continue",
  mustAcceptTerms: "You must accept the terms to continue",
  readDocumentsMessage: "To continue, read our documents:",
  termsOfUse: "Terms of Use",
  privacyPolicyLink: "Privacy Policy",
  areYouSureYouWantToExclude: "Are you sure you want to remove {ref}?",
  withVehicle: "Do you plan to come with a vehicle?",
  addVehicle: "Add Vehicle",
  removeVehicle: "Remove Vehicle",
  vehicleType: "Vehicle type",
  vehicleIndex: "Vehicle no.",
  vehicleTypeCar: "Car",
  vehicleTypeMotorcycle: "Motorcycle",
  vehicleLicensePlate: "Vehicle Model, Color, and License Plate",
  residenceWithNoGarages: "This place does not include parking",
  residenceWithLimitedGarages:
    "This property includes parking for up to {count} vehicle{suffix}",
  at: "at",
  fillCheckinTime: "Please, fill in the check-in time",
  fillCheckoutTime: "Please, fill in the check-out time",
  guestRegister: "Guest Registration",
  sections: {
    guestData: "Primary guest data",
    termsAndConditions: "Terms and conditions",
    documents: "Primary guest's documents",
    documentsSubtitle: "Add a photo of your ID, driver's license, or passport",
    additionalGuests: "Additional guests' data",
    additionalGuestSpecific: "Additional guest {nameOrIndex}'s data",
    stayDetails: "Stay details",
    stayDetailsSubtitle: "Fill in your reservation details",
  },

  residenceInfo: "Important Information",

  formSteps: {
    stayData: "Stay data",
    fillStayData: "Fill in your stay details",
    checkinTime: "Check-in time",
    checkoutTime: "Check-out time",
    arrivalLabel: "Expected arrival time (check-in)",
    arrivalNotice:
      "Please provide your exact expected arrival and departure times. It helps the host prepare your arrival.",
    arrivalHint: "Exact expected arrival time",
    departureLabel: "Expected departure time (check-out)",
    departureHint: "Exact expected departure time",
    confirm: "Confirm",
    visitPurpose: "Purpose of visit",
    cars: "Cars",
    vehicle: "Vehicle",
    vehicleType: "Vehicle type",
    vehiclePlate: "Vehicle Model/License Plate/Color",
    noGarageWarning: "This accommodation does not accept cars",
    pets: "Pets",
    pet: "Pet",
    petType: "Animal type (e.g., Dog, Cat)",
    noPetsWarning: "This accommodation does not accept pets",
    addAnimal: "Add animal",
    addAnimalInfo: "Enter the animal type",
    addVehicle: "Add vehicle",
    addVehicleInfo: "Enter the vehicle details",
    cancel: "Cancel",
    add: "Add",
    maxGuestsAllowed: "This reservation allows up to",
    companion: "companion",
    companions: "companions",
    addCompanion: "Add companion",
    removeCompanion: "Remove companion",
    thisReservationAllows: "This reservation allows",
    guestIndex: "Companion {index}",
    documentFront: "Front photo of document",
    documentBack: "Back photo of document",
    faceSelfie: "Face selfie",
    photoGuidelines: "Photo guidelines",
    followForBestResults: "Follow for best results",
    photoInWellLitPlace:
      "Photograph in a well-lit location, avoiding shadows or reflections on the document.",
    centerDocument:
      "Center the document on screen, keeping all borders visible without cuts.",
    holdPhoneSteady:
      "Hold the phone steady or rest it on a surface to avoid blurry photos and ensure sharpness.",
    takePhoto: "Take photo",
    attachPhoto: "Attach photo",
    selfieGuidelines: "Face selfie guidelines",
    faceWellLit:
      "Face a natural light source or well-lit environment to avoid shadows.",
    faceFramed:
      "Keep your entire face within the frame, looking directly at the camera.",
    removeAccessories:
      "Remove sunglasses, caps, or any items that may cover your face.",
    takeFaceSelfie: "Take face selfie",
    selfiePreviewTitle: "How did your selfie turn out?",
    selfiePreviewSubtitle: "Check the quality before continuing.",
    selfiePreviewQualityWarning:
      "Make sure your face is fully visible, well-lit, and free of accessories that cover your face.",
    selfiePreviewAccept: "Continue with this selfie",
    selfiePreviewRetake: "Retake selfie",
  },

  navigation: {
    back: "Back",
    next: "Next",
  },

  contactUs: "Questions? Talk to us",

  importantInfoBeforeContinue: "Important information before continuing",

  readAndAccept: "I accept",

  dontAccept: "I do not accept",

  validation: {
    required_birthDate: "Birth date is required",
    invalidDate: "Invalid date",
    minimumAge: "Main guest must be at least 18 years old",
    requiredCheckOutTime: "Check-out date is required",
    requiredCheckInTime: "Check-in date is required",
    TimeOutOfRange: "Unavailable time",
    checkInOutOfRange: "CheckIn time unavailable",
    checkOutOutOfRange: "CheckOut time unavailable",
    required: "This field is required",
    email: "Invalid email",
    name: "Invalid name",
    phone: "Invalid phone number",
    min_adults: "There must be at least one adult",
    children: "Number of children is required",
    validate_cpf: "Invalid Docment",
    validate_phone: "Invalid phone",
    required_cpf: "Docment is required",
    required_document: "Document is required",
    alert: "Fill in all required fields",
    checkout_greater_than_checkin:
      "Checkout date and time needs to be after checkin.",
    required_address: {
      cep: "CEP is required",
      postalCode: "Postal Code is required",
      country: "Country is required",
      city: "City is required",
      state: "State is required",
      number: "Number is required",
      street: "Street is required",
    },
    vehicle: {
      missingVehicles: "Tell us which vehicles you plan to bring.",
      missingWithVehicle:
        "Let us know if you plan to come with a vehicle or not.",
      missingVehicleType: "Vehicle type is required!",
      missingVehicleLicensePlate:
        "Vehicle model, color, and license plate are required!",
    },
    additionalGuestNameMissing:
      "The additional guest {nameOrIndex}'s name is required",
    additionalInvalidCPF: "The additional guest {nameOrIndex}'s CPF is invalid",
    additionalInvalidPhone:
      "The additional guest {nameOrIndex}'s phone number is invalid",
    missingAdditionalGuestBirthDate:
      "The additional guest {nameOrIndex}'s birth date is required",
    additionalInvalidDocument:
      "The additional guest {nameOrIndex}'s document is invalid",
    additionalMissingDocumentFront:
      "The additional guest {nameOrIndex}'s document front is missing",
    additionalMissingDocumentBack:
      "The additional guest {nameOrIndex}'s document back is missing",
    additionalMissingDocumentSelfie:
      "The additional guest {nameOrIndex}'s selfie is missing",
    missingDocumentFront: "Missing Document Front",
    missingDocumentBack: "Missing Document Back",
    missingDocumentDigital: "Missing Digital Document",
    missingDocumentSelfie: "Missing Facial Authentication",
    missingVisitPurpose:
      "The visit purpose or the option 'I prefer not to inform the purpose of the visit' is required",
    addTheAdditionalGuests: "Add the additional guests",
    additionalGuestSpecific: "Additional guest {nameOrIndex}'s data",
    mustAcceptAllTerms: "You must accept all terms to continue",
    mustAcceptUserTerms: "You must accept the terms of use to continue",
  },

  //-------------Doc---------
  doc: {
    tab1: "Physical Document<br>(Picture)",
    tab2: "Digital Document<br>(Picture or PDF)",
    front: "Front of the responsible guest's document",
    back: "Back of the responsible guest's document",
    pdf: "Attach Digital Document (PDF)",
    title1: "1. Send a photo of the front of your document",
    title2: "2. Send a photo of the back of your document",
    title3: "3. Now, let's begin the facial authentication process",
    title4: "1. Send your digital document",
    title5: "2. Now, let's begin the facial authentication process",
    text1: "Documents with photos such as RG, CNH, or Passport are accepted.",
    text1_1:
      "Remember that if it is RG or CNH, the document is usually <b>folded</b> inside a cover, so you must remove and unfold it to take the photo. Just like in the image below:",
    text2: "Send a photo of the back of the document you sent in field 1.",
    text3:
      "The process is quite simple. By clicking on 'Start Authentication,' activate your phone's camera and position your face within the designated areas.",
    text3_1:
      "We will need access to your camera. If you are using a computer without a webcam, you can complete this step on your smartphone.",
    text4: "Attach your digital document, a file containing the QR Code",
    missingDocs: "Attach all required documents!",
    missingSelfie: "Please complete facial authentication!",
    startAuthentication: "Start Authentication",
    authenticationAdditionalGuest:
      "Selfie of the additional guest {nameOrIndex}",
    startAgainAuthentication: "Saved. Do Again?",
  },

  // --------Additional Guest-----
  additionalGuest: {
    notAllowedAdditionalGuests:
      "It is not allowed to add additional guests for this reservation.",
    add: "Add new",
    askReload:
      "This option is used to retrieve data entered by the additional guests themselves through the link you sent. Are you sure?",
    reload: "Retrieve already filled data",
    fill: "Fill Data",
    view: "View Data",
    del: "Delete Guest",
    copy: "Send fill data link",
    copied: "Link copied successfully. You can send it to the additional guest",
    heading: "Additional Guest Information",
    name: "Guest's Full Name",
    cpf: "Guest's CPF",
    passport: "Guest's Passport/RNE",
    isChild: "Is a child or minor?",
    foreignCheckbox: "Foreign?",
    document: "Guest's Document (Front) or Full Document",
    documentBack: "Guest's Document (Back)",
    downloadDocument: "Ver Documento Frente",
    downloadDocumentBack: "Ver Documento Verso",
    hasAdditional: "Do you have additional guests?",
    howManyAdditional: "How many additional guests do you have?",
    facialRecognitionInfo:
      "Authentication is required for all additional guests.",
    isntPossibleToAddAdditionalGuests:
      "It is not possible to add additional guests to this reservation.",
    giveTheDipositiveToTheGuestMakeSelfie:
      "Please hand the device to the additional guest so they can take their selfie.",
    reloadedSuccess: "Data retrieved successfully!",
  },

  wait: {
    thankYou: "Thank you!",
    waitTitle: "Please wait",
    waitMessage:
      "We're processing your information. Someone from our team will contact you shortly to continue your registration.",
    callToAction: "Back to home",
  },

  // ------------PIX-----------
  cautionPayment: {
    question: "Does your reservation have a deposit?",
    cautionCoveredByAirCover:
      "Your reservation is covered by Airbnb's AirCover insurance! Click below to proceed.",
    noCautionMessage: "Your reservation does not have a deposit.",
    heading: "Security Deposit",
    howItWorks: "How it works?",
    subheading: "Fill in your reservation details",
    cautionValue:
      "The security deposit amount for this reservation is: R$ {value}",
    cautionValueMessage:
      "The value of this deposit is <strong>{value}</strong>.",
    pixKeyLabel: "Pix key",
    attachProof: "Attach payment proof",
    copied: "Pix key copied successfully!",
    missingCautionPayment:
      "It is necessary to attach the proof of payment of the deposit",
    downloadProof: "Download payment proof",
    replaceProof: "Replace payment proof",
    selectMethod: "Select payment method",
    creditCard: "Credit Card (Pre-authorization)",
    pix: "Pix",
    insurance: "Check-in Insurance",
    bestOption: "BEST OPTION",
    whatIsCaution: "What is a security deposit?",
    processedBy: "Processed by",
    paymentWindowError:
      "The security deposit payment must be made between {startDate} and {endDate}.",
    preAuthLabel: "PRE-AUTHORIZATION",
    cardData: "Card data",
    cardNumber: "Card number",
    cardHolder: "Cardholder name",
    expirationMonth: "Month",
    expirationYear: "Year",
    cvv: "Security code (CVV)",
    installments: "Installments",
    preAuthWarning:
      "Pre-authorization occurs up to 3 days before check-in. Please ensure there is available credit limit during this period.",
    billingAddress: "Billing address",
    useReservationAddress: "Use address from Reservation?",
    complement: "Complement",
    zipCode: "Zip code",
    city: "City",
    state: "State",
    number: "Number",
    street: "Street",
    missingPaymentMethod: "Select a payment method for the deposit",
    paymentRequired: "The security deposit payment is required",
    missingCardNumber: "Card number is required",
    missingCardHolder: "Cardholder name is required",
    missingExpirationMonth: "Expiration month is required",
    missingExpirationYear: "Expiration year is required",
    missingCvv: "CVV is required",
    missingZipCode: "Zip code is required",
    missingCity: "City is required",
    missingState: "State is required",
    missingStreet: "Street is required",
    missingAddressNumber: "Number is required",
    missingNeighborhood: "Neighborhood is required",
    pixGeneratedNextStep:
      "Your PIX will be generated in the next step for immediate payment.",
    pixTimerMessage: "You have {minutes} minutes to complete the payment.",
    pixExpired: "Payment not completed",
    pixTryAgain: "Try again",
    pollingTimeout: "Payment confirmation timeout. Please try again.",
    comingSoon: "Coming soon",
    apiErrors: {
      GUEST_NOT_FOUND: "Guest not found.",
      NO_CAUTION_VALUE:
        "No security deposit amount is configured for this reservation.",
      INCOMPLETE_GUEST_DATA:
        "Incomplete data. Please fill in your name, email, CPF, and phone number before paying.",
      INVALID_PHONE: "Invalid phone number. Please check the number provided.",
      CAUTION_PERIOD_EXPIRED: "The security deposit payment period has ended.",
      LONG_STAY_NO_CREDIT_CARD:
        "Credit Card payment is not available for reservations longer than 30 days.",
      CREDIT_CARD_TOO_EARLY:
        "Credit Card payment is only available 30 days before checkout.",
      CAUTION_PAYMENT_PENDING:
        "Security deposit payment via credit card has not been confirmed yet. Complete the payment before submitting.",
    },
    loadingPayment: "Loading secure payment environment...",
    secureEnvironment: "Payment processed in Pagar.me secure environment",
    paymentConfirmed: "Security deposit confirmed successfully!",
    alreadyPaidTitle: "Deposit already paid",
    alreadyPaidSubtitle: "The security deposit was already paid earlier. You can continue without paying again.",
    pixModalTitle: "Security Deposit Payment",
    pixPaymentRealized: "Payment Realized!",
    pixPaymentIdentifiedWait:
      "The payment was successfully identified. Please wait a moment...",
    pixPaymentIdentified: "The payment was successfully identified.",
    pixModalDescription:
      "Scan the QR Code below to make the payment via PIX. Confirmation is instant.",
    pixCopyPasteLabel: "PIX Copy and Paste Code",
    pixModalWarning:
      "Do not close this page. The system will automatically proceed after payment confirmation.",
    pixModalWaiting: "Waiting for bank confirmation...",
    iframeError: "Error loading payment. Please try again.",
    retryPayment: "Try again",
    confirmPreAuth: "Confirm pre-authorization",
    cautionBlocked:
      "The security deposit payment period has ended because the reservation has already passed the checkout date.",
    longStayNoCreditCard:
      "For reservations longer than 30 days, security deposit payment via Credit Card is not available. Please use the PIX option.",
    creditCardReleaseDateMessage:
      "Credit Card payment for the security deposit is available 30 days before the checkout date - {date}",
  },
  talkOnWhatsApp: "Go to WhatsApp",

  imageTermsContent: {
    title: "TERMS OF USE / IMAGE USE TERMS",
    content: `We at "Selfie Check-in" take your privacy and the protection of your data seriously. That is why we have created our Privacy Policy ("Policy"), so that you, our user ("Users"), can check i) what personal information is collected; ii) how such personal information is used and shared; and iii) what privacy rights our users have.

Our policy applies when you use our websites, fill out our forms or hire our services.

Cookies are small text files (usually encrypted) that are stored in browsers after the user accesses a website. They make it possible to identify the access device used.

By accessing the website, the user acknowledges being solely responsible for the truthfulness, accuracy and authenticity of the data provided, and also undertakes to safeguard, keep confidential and make proper use of any registered login and password.

MADE SIMPLE: TERMS AND CONCEPTS YOU NEED TO KNOW

Encryption
Encryption is a security and privacy mechanism used to encode and decode data. Its purpose is to protect confidential information from threats and unauthorized access.

Cookies

CRM
Acronym for Customer Relationship Management.

Personal Data
Any information relating to a natural person that is capable of identifying that person or making their identification possible.

IP (Internet Protocol)
The Internet Protocol, whose purpose is to identify each device connected to the network by means of a unique number.

Processing
Any form of use we may make of your Personal Data, including, but not limited to, the following activities: collection, storage, consultation, use, sharing, transmission, classification, reproduction, deletion and evaluation.

Data Subject
You, the natural person to whom the Personal Data refers.

WHEN AND WHAT DATA IS COLLECTED

Selfie Check-in may collect data whenever there is active and voluntary interaction by the user when registering on the website, and also through the use of our communication channels, which include: (a) corporate WhatsApp numbers (Selfie Check-in central line and emergency support), (b) communication via platform chats (Airbnb, Booking, Expedia and others), (c) contact via e-mail, (d) registration on the website, (e) telephone contact via landline.

Browsing data of website visitors
• IP addresses used;
• Clicks; and
• Visit durations.

This data is collected through "cookies", which make your online experience easier, faster and more accessible by saving browsing information.

Registration data
• Full Name
• E-mail
• CNH (Brazilian driver's license)
• RNE (Brazilian foreigner registration) for foreign users
• Passport for foreign users
• Sex
• Date of birth
• CPF (Brazilian taxpayer ID)
• Nationality
• Language
• RG (Brazilian ID card)
• Mobile phone
• CEP (postal code)
• Address
• City/State
• Password
• Birth certificate for minors

Payment data
• Bank Details
• Payment method: credit card, Pix, PayPal or bank transfer)

In addition to the payment instruments used, the date and time, payment amount, expiration date of the payment instrument and billing postal code, PayPal e-mail address, user's address and other transaction-related information may also be collected as a means of protection against and prevention of fraud.

Documents collected
To make and complete bookings, the following documents must be sent:
• Photo of the front and back of the identification document: RG, CNH, RNE and passport for foreign users;
• Birth certificate, or another official document showing the relationship, in the case of minors (Pursuant to Law No. 8,069/1990, presentation of the minor's identification document is required to make the booking.)
• Photo of the booking holder holding the document.

PURPOSE OF DATA COLLECTION

The personal data collected may be used in the following ways:
✔ To enable the use and experience of the contracted services;
✔ To produce statistics, studies, research and surveys relevant to activities and behavior in the use of the Services, carrying out such operations in anonymized form;
✔ To allow your participation in promotions and the dissemination of marketing materials;
✔ To process payments and enable the provision of the service offered by the website;
✔ For Communication, including sending important notices and notifications related to the user, such as changes to this Policy, new products/services and satisfaction surveys;
✔ Compliance with legal obligations and defense of rights, and the data may be used to comply with legal or regulatory obligations, as well as to defend rights in judicial or out-of-court disputes;
✔ To process payment for the products selected by the user; To respond to the user's requests;
✔ To implement and provide improvements/enhancements to the provision of the services themselves.

DATA SHARING

Users' personal data will always be shared within legal limits, observing in particular the provisions of Law No. 13,709/2018 ("LGPD", the Brazilian General Data Protection Law), always taking into account the purposes of the relationship between the website and the user and the business carried out by "Selfie Check-in".

Users' personal data may be shared with companies of the same group, subsidiaries, affiliates, partners, suppliers and service providers, for legitimate purposes, as follows:
✔ To carry out the personal data processing activities described above, including the storage of the personal data collected;
✔ To comply with legal, regulatory or contractual obligations;
✔ To exercise legitimate interest;
✔ As a means of preventing fraud and protecting users' data

Partners are only authorized to use personal data for the purposes for which they were hired, and the use of users' personal data for purposes other than the provision of the contractually agreed services is prohibited.

DATA STORAGE

Users' personal data will be stored only for as long as necessary to achieve the purposes set out herein.

For audit purposes and to preserve users' rights, data may be stored for a maximum period of 5 (five) years from the cancellation of any access account, which may be extended for a longer period where the law or regulatory standards so require, or to preserve rights.

PROCESSING OF SENSITIVE DATA – FACIAL RECOGNITION

In the course of providing its services, Selfie Check-in may process biometric data (facial images) for the purposes of identity verification and fraud prevention in the check-in process.

This data is classified as sensitive personal data, as provided for in art. 5, II, of the LGPD. Processing will be carried out in strict compliance with the legal bases set out in art. 11 of the LGPD, in particular:

To comply with a legal or regulatory obligation, where applicable;

Facial recognition will be used exclusively to verify the guest's identity and ensure the security of the stay, and will not be used for any other incompatible purpose.

The biometric information collected will be stored in a secure environment, using encryption, restricted access control and audit logs, and will be discarded or anonymized as soon as the purpose for which it was obtained has been fulfilled, subject to legal retention periods.

The data subject may revoke the consent given for this processing at any time by submitting a request to the Data Protection Officer (DPO), being aware that revocation may make automated check-in impossible.

USERS' RIGHTS

Under the LGPD, users have rights and guarantees regarding their data. We provide mechanisms, detailed below, so that our users have clarity and transparency in exercising their rights.

Users may:
✔ Request details and/or a copy of their data stored by Selfie Check-in;
✔ Change or correct their data, upon request by e-mail or WhatsApp;
✔ Confirm the existence of data processing;
✔ Correct incomplete, inaccurate or outdated data;
✔ Obtain the anonymization, blocking or deletion of unnecessary or excessive data, or data processed in breach of the LGPD;
✔ Request the portability of data to another service or product provider, upon express request, in accordance with the regulations of the National Authority, subject to commercial and industrial secrets;
✔ Delete personal data processed with the consent of the data subject, except in the cases provided for in art. 16 of the Law;
✔ Request information about the public and private entities with which the Controller has shared data;
✔ Request information about the possibility of not giving consent and about the consequences of refusal;
✔ Request revocation of consent, under § 5 of art. 8 of the Law.

To exercise any of your rights or clarify any questions, contact contato{'@'}selfiecheckin.com.br

DATA PROTECTION

Selfie Check-in stores data in operating environments that use technical and administrative security measures to prevent any type of unauthorized access and accidental or unlawful destruction, loss, alteration, communication or dissemination, using security technologies and procedures to help protect personal data against improper access, such as, for example, the use of two-factor authentication to access the system, which the user must configure.

All data collected is stored in a secure and controlled environment for a minimum period of 6 (six) months, pursuant to the Marco Civil da Internet (Brazilian Internet Civil Framework).

Data may be stored on our own servers or on those of a third party hired for this purpose, whether located in Brazil or abroad, in accordance with the LGPD.

Selfie Check-in may provide owners/hosts with mechanisms to record reviews and comments about stays made by users. These reviews may contain information about behavior, compliance with property rules and stay history, constituting personal data linked to the data subject.

The purposes of processing this data are:
to ensure greater transparency and security in the relationship between guests and hosts;
to allow a trustworthy environment to be maintained on the platform;
to support any measures to prevent fraud or breaches of contract.

Reviews will remain stored for the period necessary to fulfill these purposes, and may be accessed by the respective owners and, where applicable, used by Selfie Check-in for statistical analysis or service improvement.

PLATFORMS SUBJECT TO DATA SHARING

1. Cloud, AWS
2. Stripe
3. D4S Serviços em Tecnologia
4. Airbnb
5. Booking
6. Expedia
7. TripAdvisor
8. Persons responsible for cleaning/maintenance/front desk/caretakers/housekeepers (individuals)
9. Owners (individuals)
10. Selfie Check-in Team
11. Paypal
12. Meta (Facebook, Instagram, Whatsapp)
13. Google (gmail, Google drive)
14. Microsoft (Outlook, Teams, One Drive)
15. Building front desk/concierge systems.

Partner Promotions and Benefits

Our platform may provide the customer with information about promotions, discounts and benefits offered by partners, such as car rental services, accommodation bookings, transportation or other related activities.

Access to these promotions occurs exclusively on the customer's initiative, through links or redirects to the respective partners' websites or applications.

It should be clarified that:
• No personal data is shared between our platform and the partners at the time of access.
• Any collection and processing of personal data is then governed exclusively by the partner's privacy policy, which we recommend consulting before continuing to use the service.
• Our platform merely provides information about the promotion, without any involvement in the processing of personal data or in the provision of the service contracted with the partner.

CHANGES TO THIS POLICY

The provisions of this Policy may be changed at any time. Whenever the Policy is changed, the changes will be published on the Platform's website and may be sent by e-mail.

CONTACT

Any privacy-related questions may be sent to Selfie Check-in's Data Protection Officer (DPO) by e-mail: dpo{'@'}selfiecheckin.com.br

Data sharing: may occur with payment processors

Last Modified: October 2026

Selfie Check-in processes (e.g., PayPal, Stripe), cloud hosting service providers, personal data in strict compliance with the General Data Protection Law (Law No. 13,709/2018 – LGPD) and the guidelines of the National Data Protection Authority (ANPD). The data lifecycle comprises collection, storage, use, sharing and subsequent deletion or anonymization, observing legal retention periods and specific purposes.

Data collected: full name, identification documents (RG/CPF, passport), address, telephone, e-mail, bank and payment details, photograph/profile, information on behavior history and reviews, as well as geolocation data during check-in/check-out, where applicable.

e-mail providers, fraud risk analysis services, public authorities when necessary, and partners hired to perform the services.

Security: appropriate technical and administrative measures are adopted, including encryption at rest and in transit, multi-factor authentication, access logs, firewalls, antivirus software and periodic backup routines, with access restricted to administrators, moderators and technical support.

Data subjects' rights: users may exercise the rights provided for in art. 18 of the LGPD (access, correction, deletion, anonymization, blocking, portability, revocation of consent, among others) by submitting a request to the Data Protection Officer (DPO) through the channel indicated in this Policy`,
  },

  termsOfUseContent: {
    title: "TERMS AND CONDITIONS OF USE – SELFIE CHECK-IN",
    content: `1. Acceptance of Terms

By accessing and using the Selfie Check-in platform, the user declares that they have read, understood and agree to fully comply with these Terms of Use, as well as with the Privacy Policy available on the website.

2. Purpose

Selfie Check-in provides a digital platform designed to facilitate automated check-in processes at accommodation properties, enabling the collection and validation of guest data, communication with owners/hosts and reservation management.

3. Conditions of Use

- The user undertakes to provide true, complete and up-to-date information.
- Use of the platform is restricted to persons over 18 years of age or to minors duly authorized by their legal representatives.
- Any unlawful or fraudulent use, or any use that may compromise the security of the platform or of third parties, is prohibited.

4. Registration and User Account

- To access certain features, the user may need to create an account, choosing access credentials (login and password).
- The user is responsible for the confidentiality of their credentials and for all activities carried out in their account.
- Selfie Check-in reserves the right to suspend or cancel accounts that violate these Terms.

5. Personal Data and Privacy

- The processing of personal data, including sensitive data (e.g., facial biometrics), is governed by the Selfie Check-in Privacy Policy, prepared in accordance with the LGPD (Brazilian General Data Protection Law – Law No. 13,709/2018).
- The user acknowledges that certain features (e.g., facial recognition for fraud prevention) depend on the provision of express consent.

6. Responsibilities of Selfie Check-in

Selfie Check-in undertakes to:

- Ensure the regular operation of the platform, except in situations of maintenance, updates or force majeure;
- Protect users' personal data, adopting appropriate technical and administrative measures;
- Comply with applicable legislation on privacy, data protection and consumer protection.

7. User Responsibilities

The user undertakes to:

- Use the platform only for legally permitted purposes;
- Not reproduce, copy, distribute or modify any part of the platform without prior authorization;
- Not access restricted areas or Selfie Check-in systems by unauthorized means.

8. Intellectual Property

All platform content (trademarks, logos, software, texts, images and design) is the property of Selfie Check-in or of third-party licensors, and its use without express authorization is prohibited.

9. Limitation of Liability

- Selfie Check-in is not liable for damages resulting from internet connection failures, third-party systems or improper use of the platform.
- The liability of Selfie Check-in is limited to the services it provides, within the limits permitted by law.

10. Changes to the Terms of Use

Selfie Check-in may change these Terms of Use at any time. Changes will be published on the website and will take effect on the date of their publication. Continued use of the platform implies acceptance of the new conditions.

11. Contact

For any questions about these Terms of Use, the user may contact Selfie Check-in by email: contato{'@'}selfiecheckin.com.br

12. Governing Law and Jurisdiction

These Terms of Use are governed by Brazilian law (LGPD and consumer protection regulations), and the courts of the district where Selfie Check-in is headquartered are elected to settle any disputes, except where the law establishes a different jurisdiction.`,
  },
  homeV2: {
    hero: {
      titleLine1: "The whole guest journey.",
      titleLine2: "One platform.",
      subtitle: "Automation, security and AI to connect your operation, from booking to post-stay.",
      ctaPrimary: "Learn more",
      ctaSecondary: "Talk to our team",
      mockupAlt: "Selfie Check-in dashboard showing bookings, pending check-ins and the status of each guest",
    },
    logos: {
      label: "Integrated platforms",
    },
    pillars: {
      titleLead: "The hospitality is yours.",
      titleAccent: "The connection is on Selfie.",
      lead: "Documents to review, messages to answer and access to coordinate. Bring the stages of hosting together and follow every booking with more organisation.",
      automation: {
        title: "Automation that follows the booking.",
        text: "Digital check-in, notifications and integrations connect guest information to the day-to-day of your operation.",
      },
      security: {
        title: "Security to decide with context.",
        text: "Documents, selfie and validations gather information to support the arrival review. Security deposit and electronic signature complete the journey.",
      },
      ai: {
        title: "AI present throughout the stay.",
        text: "An agent supports check-in, answers questions about the property and routes situations that need a human.",
      },
    },
    journey: {
      titleLine1: "A complete journey.",
      titleAccent: "Stages",
      titleAfter: " that connect.",
      lead: "From the first contact to the stay history, each stage prepares the next.",
      step1: {
        title: "Booking",
        text: "The host registers the property and the booking details to start the guest journey on the platform.",
      },
      step2: {
        title: "Communication",
        text: "The guest receives the hosting instructions and the link to complete digital check-in before arrival.",
      },
      step3: {
        title: "Check-in",
        text: "The guest fills in their details and submits documents and a selfie through the digital form.",
      },
      step4: {
        title: "Validation",
        text: "The data is verified and a criminal background check is run via SERPRO. If there is a record, the host is notified to review the booking.",
      },
      step5: {
        title: "Security deposit",
        text: "The deposit provides a financial guarantee for possible damages, giving the host more security under the terms agreed for the stay.",
      },
      step6: {
        title: "Access",
        text: "After approval, the front desk receives the entry information. Access through smart locks can be automated depending on the available integration.",
      },
      step7: {
        title: "Stay",
        text: "The guest opens the Guest Guide, with instructions about the property and local tips, and has support during the stay.",
      },
      step8: {
        title: "Post-check-out",
        text: "Booking data, check-in and the stay history stay on file for future reference. The guest can be invited to rate their experience.",
      },
    },
    ai: {
      badge: "Artificial intelligence",
      title: "An AI agent that helps you manage stays",
      lead: "Technology supports you while you focus on what really matters.",
      phoneAlt: "Selfie Check-in messages screen with the chatbot assisting guests",
      before: {
        title: "Before arrival",
        text: "Collects information and follows the progress of check-in.",
      },
      during: {
        title: "During the stay",
        text: "Answers questions using information about the property.",
      },
      after: {
        title: "After check-out",
        text: "Can request the guest's review.",
      },
      human: {
        title: "When a person is needed",
        text: "Routes situations to human support.",
      },
    },
    checkin: {
      eyebrow: "Booking and registration",
      title: "Digital check-in before arrival and identity validation",
      photoAlt: "Guest taking a selfie with their phone at the door of the property",
      document: {
        title: "Document",
        text: "Review of the data submitted by the guest.",
      },
      selfie: {
        title: "Selfie",
        text: "Facial comparison against the document provided.",
      },
      verification: {
        title: "Security check",
        text: "Official data lookup via SERPRO.",
      },
    },
    integrations: {
      eyebrow: "A more aligned operation",
      title: "Connection across every point of contact",
      lead: "Host, property manager, owners and front desk: information shared to prepare the arrival and follow the booking.",
      hostPhotoAlt: "Host checking the booking on their phone",
      gatePhotoAlt: "Doorman monitoring the cameras and the booking record at the front desk",
      pms: {
        title: "Bookings and PMS",
        text: "Connection with booking managers to support the hosting flow.",
      },
      gate: {
        title: "Front desks and buildings",
        text: "Booking confirmation and record after approval, with building integration where supported.",
      },
      locks: {
        title: "Smart locks",
        text: "Access automation according to the available integration.",
      },
      messaging: {
        title: "WhatsApp and email",
        text: "Notifications that keep everyone involved informed about the booking and the check-in.",
      },
    },
    testimonials: {
      title: "Selfie Check-in is already part of the hosting routine",
      lead: "More organisation for whoever hosts, more care for whoever arrives. See how Selfie Check-in can simplify the routine and make room for what matters: welcoming people well.",
      feature: "Fewer manual tasks in managing stays.",
      mario: {
        name: "Mario Costa",
        role: "Host of short-term rental apartments",
        quote: "“I used to chase documents and track every detail over WhatsApp. With Selfie Check-in the guest sends everything through the form and I can see what is still missing before arrival. My routine got much more organised.”",
      },
      rafael: {
        name: "Rafael Almeida",
        role: "Short-term rental property manager",
        quote: "“One of the most laborious parts was aligning the arrival with the front desk. With Selfie, the booking information reaches everyone involved after approval. That made communication easier and cut down the back and forth of messages.”",
      },
      bruna: {
        name: "Bruna Martins",
        role: "Host of holiday homes",
        quote: "“Guests tend to ask similar questions about the property. Having a guide and AI support in the conversation helps me answer those and give more attention to the situations that really need me.”",
      },
    },
    faq: {
      eyebrow: "Frequently asked questions",
      title: "Questions every host asks",
      q1: {
        question: "How does digital check-in work for the guest?",
        answer: "The guest receives a link and fills in a form with their details, documents and a selfie before arrival. The operation follows the submission and the validation of the information to prepare the entry.",
      },
      q2: {
        question: "How does Selfie Check-in help validate guests' identity?",
        answer: "The platform brings together the document review, the facial comparison with the selfie and the lookups available according to the plan contracted. This information supports the host's review and decision.",
      },
      q3: {
        question: "What can the AI agent answer, and when does a person take over?",
        answer: "The agent can support filling in the check-in and answer questions using the property information. When a situation needs human attention, it routes the conversation to the responsible team.",
      },
      q4: {
        question: "Does the platform integrate with my booking system, the front desk and smart locks?",
        answer: "Selfie Check-in offers integrations to connect these stages of the operation. Compatibility with the systems you use and the automation possibilities are verified during onboarding.",
      },
      q5: {
        question: "How do the security deposit and the electronic signature work?",
        answer: "The platform lets you add the deposit to the journey and formalise hosting documents with an electronic signature. Payment methods, guarantee terms and release rules are defined in the operation settings.",
      },
      q6: {
        question: "What do I need to start using Selfie Check-in in my properties?",
        answer: "Get in touch with the team to see the platform and present your operation. During onboarding we align the property registration, the features contracted and the integrations compatible with the systems you already use.",
      },
    },
    footer: {
      home: "Home",
      about: "About",
      plans: "Plans",
      contact: "Contact",
      addressLine1: "Rua Tupi - Nº228, Santa Cecília, São Paulo - SP, Brazil",
      addressLine2: "ZIP 01233-000 {'|'} Company ID 56.107.848/0001-79",
      terms: "Terms and Conditions of Use",
      imageTerms: "Terms of Use / Image Use Terms",
    },
  },
};

export default en;
